import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "psb-page" }
const _hoisted_2 = { class: "psb-page__container" }
const _hoisted_3 = { class: "psb-header" }
const _hoisted_4 = {
  key: 0,
  class: "psb-header__brand"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "psb-stepper" }
const _hoisted_7 = { class: "psb-stepper__num" }
const _hoisted_8 = { class: "psb-stepper__label" }
const _hoisted_9 = { class: "psb-layout" }
const _hoisted_10 = { class: "psb-layout__side" }
const _hoisted_11 = { class: "psb-summary" }
const _hoisted_12 = { class: "psb-summary__method" }
const _hoisted_13 = { class: "psb-badge" }
const _hoisted_14 = { class: "psb-summary__label" }
const _hoisted_15 = { class: "psb-summary__amount" }
const _hoisted_16 = { class: "psb-summary__label" }
const _hoisted_17 = { class: "psb-summary__timer" }
const _hoisted_18 = { class: "psb-summary__direction" }
const _hoisted_19 = {
  key: 0,
  class: "psb-qr psb-desktop"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "psb-qr__body" }
const _hoisted_22 = { class: "psb-qr__title" }
const _hoisted_23 = { class: "psb-qr__text" }
const _hoisted_24 = { class: "psb-layout__main" }
const _hoisted_25 = {
  key: 0,
  class: "psb-card"
}
const _hoisted_26 = { class: "psb-card__head" }
const _hoisted_27 = { class: "psb-card__title" }
const _hoisted_28 = { class: "psb-progress" }
const _hoisted_29 = { class: "psb-card__subtitle psb-mobile" }
const _hoisted_30 = { class: "psb-card__subtitle psb-desktop" }
const _hoisted_31 = { class: "psb-route" }
const _hoisted_32 = { class: "psb-route__chip" }
const _hoisted_33 = { class: "psb-route__via" }
const _hoisted_34 = { class: "psb-route__chip" }
const _hoisted_35 = { class: "psb-open__icon" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "psb-open__text" }
const _hoisted_38 = { class: "psb-fields" }
const _hoisted_39 = { class: "psb-field__body" }
const _hoisted_40 = { class: "psb-field__label" }
const _hoisted_41 = { class: "psb-field__value" }
const _hoisted_42 = ["aria-label", "onClick"]
const _hoisted_43 = { class: "psb-steps" }
const _hoisted_44 = { class: "psb-steps__num" }
const _hoisted_45 = { class: "psb-steps__text" }
const _hoisted_46 = { class: "psb-hint psb-mobile" }
const _hoisted_47 = { class: "psb-hint psb-desktop" }
const _hoisted_48 = {
  key: 0,
  class: "psb-trx"
}
const _hoisted_49 = {
  class: "psb-trx__label",
  for: "psb-trx-input"
}
const _hoisted_50 = ["value", "placeholder"]
const _hoisted_51 = {
  key: 0,
  class: "psb-trx__error"
}
const _hoisted_52 = {
  key: 1,
  class: "psb-card psb-status"
}
const _hoisted_53 = { class: "psb-status__title" }
const _hoisted_54 = { class: "psb-status__text" }
const _hoisted_55 = {
  key: 0,
  class: "psb-upload"
}
const _hoisted_56 = {
  key: 1,
  class: "psb-status__note"
}
const _hoisted_57 = { class: "psb-status__title" }
const _hoisted_58 = { class: "psb-status__text" }
const _hoisted_59 = { class: "psb-status__title" }
const _hoisted_60 = { class: "psb-status__text" }
const _hoisted_61 = ["href"]

import "@/assets/css/psb-cross-border.css"
import {computed, onMounted, onUnmounted, ref} from "vue";
import {useI18n} from "vue-i18n";
import QRCode from "qrcode-svg";
import DealDTO from "@/models/DealDTO";
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
import APIClient from "@/service/APIClient";
import copyTextToClipboard from "@/service/CopyHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper";
import {copy, openDeeplink, state as copyState} from "@/service/helper";
import {DealStatus} from "@/enum/DealStatus";
import {InvoiceStatus} from "@/enum/InvoiceStatus";

const PSB_METHOD = 'promsvyaz'


export default /*@__PURE__*/_defineComponent({
  __name: 'PSBCrossBorderPage',
  props: {
    confirmTransfer: { type: Function },
    cancelDeal: { type: Function },
    currentDeal: {},
    invoice: {},
    transactionId: {},
    transactionIdError: {}
  },
  emits: ["update:transactionId"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const {t, te} = useI18n({useScope: 'global'})
const api = new APIClient()

const now = ref(Date.now())
const receiptUploaded = ref(false)
let timer: number | null = null

onMounted(() => {
  timer = window.setInterval(() => {
    now.value = Date.now()
  }, 1000)
})

onUnmounted(() => {
  if (timer !== null) {
    clearInterval(timer)
  }
})

const steps = [
  {n: 1, label: 'psb-cross-border.steps.pay'},
  {n: 2, label: 'psb-cross-border.steps.verify'},
  {n: 3, label: 'psb-cross-border.steps.result'},
]

const isFinal = computed(() => [InvoiceStatus.PAID, InvoiceStatus.CANCELED, InvoiceStatus.EXPIRED].includes(props.invoice.status)
  || [DealStatus.COMPLETED, DealStatus.CANCELED].includes(props.currentDeal.status))

const phase = computed<'pay' | 'verify' | 'result'>(() => {
  if (isFinal.value) {
    return 'result'
  }
  return props.currentDeal.status === DealStatus.TRANSFER_WAITING ? 'pay' : 'verify'
})

const activeStep = computed(() => ({pay: 1, verify: 2, result: 3})[phase.value])

const stepClass = (n: number) => ({
  'is-active': n === activeStep.value,
  'is-done': n < activeStep.value,
})

const isPaid = computed(() => props.invoice.status === InvoiceStatus.PAID || props.currentDeal.status === DealStatus.COMPLETED)
const isDispute = computed(() => props.currentDeal.status === DealStatus.DISPUTE)
const canUploadReceipt = computed(() => props.currentDeal.status === DealStatus.TRANSFER_CONFIRMED
  && props.invoice.flowData?.options?.hideUploadReceipt !== true)
const returnUrl = computed(() => isPaid.value ? props.invoice.successUrl : props.invoice.cancelUrl)

const brand = computed(() => props.invoice.flowData?.options?.brand)

const amountText = computed(() => numberFormatter.formatMoney(Number(props.invoice.sum.amount), props.invoice.sum.currency))

const amountForCopy = computed(() => {
  const amount = Number(props.invoice.sum.amount)
  return Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace('.', ',')
})

const deadline = computed(() => new Date(props.currentDeal.canceledAt).getTime())

const timeLeft = computed(() => {
  const seconds = Math.max(0, Math.floor((deadline.value - now.value) / 1000))
  const minutes = Math.floor(seconds / 60)
  return `${String(minutes).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`
})

const timePercent = computed(() => {
  const createdAt = new Date(props.currentDeal.createdAt).getTime()
  const total = deadline.value - createdAt
  if (total <= 0) {
    return 0
  }
  return Math.min(100, Math.max(0, (deadline.value - now.value) / total * 100))
})

const countryName = computed(() => {
  const currency = props.invoice.crossBorderCurrency
  return currency && te(`countries.${currency}`) ? t(`countries.${currency}`) : null
})

const direction = computed(() => countryName.value
  ? t('psb-cross-border.direction', {country: countryName.value})
  : t('psb-cross-border.direction-no-country'))

const recipientLabel = computed(() => {
  const method = props.currentDeal.paymentMethod
  if (method && method !== PSB_METHOD && te(`methods.${method}`)) {
    return t(`methods.${method}`)
  }
  return countryName.value ?? t('psb-cross-border.recipient')
})

const phoneDigits = computed(() => String(props.currentDeal.requisites?.requisites ?? '').replace(/\D/g, ''))

const phoneText = computed(() => {
  const digits = phoneDigits.value
  if (digits.length === 11 && digits.startsWith('7')) {
    return `+7 ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9)}`
  }
  if (digits.length === 12) {
    return `+${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`
  }
  if (digits.length === 11) {
    return `+${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`
  }
  return digits ? `+${digits}` : String(props.currentDeal.requisites?.requisites ?? '')
})

const fields = computed(() => [
  {label: 'psb-cross-border.field-phone', value: phoneText.value, copy: String(props.currentDeal.requisites?.requisites ?? '')},
  {label: 'psb-cross-border.field-amount', value: amountText.value, copy: amountForCopy.value},
  {label: 'psb-cross-border.field-purpose', value: t('psb-cross-border.purpose'), copy: t('psb-cross-border.purpose')},
])

const isDesktop = ref(window.matchMedia('(min-width: 769px)').matches)

const instructionSteps = computed(() => [
  t(isDesktop.value ? 'psb-cross-border.instruction.step-1-desktop' : 'psb-cross-border.instruction.step-1-mobile'),
  t('psb-cross-border.instruction.step-2'),
  t('psb-cross-border.instruction.step-3', {amount: amountText.value}),
  t('psb-cross-border.instruction.step-4', {purpose: t('psb-cross-border.purpose')}),
  t('psb-cross-border.instruction.step-5'),
  t('psb-cross-border.instruction.step-6'),
])

const qrSvg = computed(() => new QRCode({
  content: window.location.href,
  join: true,
  container: 'svg-viewbox',
  padding: 0,
  color: '#0B1638',
  background: '#FFFFFF',
}).svg())

const openBank = () => {
  copyTextToClipboard(null, amountForCopy.value)
  const deeplinks = props.invoice.flowData?.deeplinks
  if (Array.isArray(deeplinks) && deeplinks.length > 0) {
    openDeeplink(deeplinks)
  }
}

const onTransactionIdInput = (e: Event) => {
  emit('update:transactionId', (e.target as HTMLInputElement).value)
}

const onReceiptSelected = async (e: Event) => {
  const file = (e.target as HTMLInputElement).files?.[0]
  if (!file) {
    return
  }
  await api.confirmTransfer(props.invoice.id, props.currentDeal.id, file)
  receiptUploaded.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        (brand.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: `/img/logo/${brand.value}-on-light.png`,
                alt: ""
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("ol", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (item) => {
            return _createElementVNode("li", {
              key: item.n,
              class: _normalizeClass(["psb-stepper__item", stepClass(item.n)])
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.n), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(item.label)), 1)
            ], 2)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("section", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.$t('psb-cross-border.transfer-via')) + " ", 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('psb-cross-border.bank-short')), 1)
            ]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('psb-cross-border.to-pay')), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(amountText.value), 1),
            (phase.value === 'pay')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('psb-cross-border.time-left')), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(timeLeft.value), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, _toDisplayString(direction.value), 1)
          ]),
          (phase.value === 'pay')
            ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                _createElementVNode("div", {
                  class: "psb-qr__code",
                  innerHTML: qrSvg.value
                }, null, 8, _hoisted_20),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('psb-cross-border.qr-title')), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('psb-cross-border.qr-text')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_24, [
          (phase.value === 'pay')
            ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h1", _hoisted_27, _toDisplayString(_ctx.$t('psb-cross-border.title')), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", {
                      class: "psb-progress__fill",
                      style: _normalizeStyle({width: timePercent.value + '%'})
                    }, null, 4)
                  ])
                ]),
                _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('psb-cross-border.subtitle-mobile')), 1),
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('psb-cross-border.subtitle-desktop')), 1),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('psb-cross-border.bank-short')), 1),
                  _createElementVNode("span", _hoisted_33, "→ " + _toDisplayString(_ctx.$t('psb-cross-border.via-sbp')) + " →", 1),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(recipientLabel.value), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "psb-open psb-mobile",
                  onClick: _withModifiers(openBank, ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_35, [
                    _createElementVNode("img", {
                      src: _unref(paymentMethodsHelper).getLogo('promsvyaz'),
                      alt: ""
                    }, null, 8, _hoisted_36)
                  ]),
                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('psb-cross-border.open-bank')), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("svg", {
                    class: "psb-open__chevron",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M9 5L16 12L9 19",
                      stroke: "currentColor",
                      "stroke-width": "2.4",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (field) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: field.label,
                      class: "psb-field"
                    }, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t(field.label)), 1),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(field.value), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "psb-field__copy",
                        "aria-label": _ctx.$t('psb-cross-border.copy'),
                        onClick: _withModifiers(($event: any) => (_unref(copy)(null, field.copy)), ["prevent"])
                      }, _cache[3] || (_cache[3] = [
                        _createElementVNode("svg", {
                          width: "22",
                          height: "22",
                          viewBox: "0 0 24 24",
                          fill: "none"
                        }, [
                          _createElementVNode("rect", {
                            x: "8",
                            y: "8",
                            width: "12",
                            height: "12",
                            rx: "2.5",
                            stroke: "currentColor",
                            "stroke-width": "1.8"
                          }),
                          _createElementVNode("path", {
                            d: "M16 8V6.5C16 5.11929 14.8807 4 13.5 4H6.5C5.11929 4 4 5.11929 4 6.5V13.5C4 14.8807 5.11929 16 6.5 16H8",
                            stroke: "currentColor",
                            "stroke-width": "1.8"
                          })
                        ], -1)
                      ]), 8, _hoisted_42)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("ol", _hoisted_43, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instructionSteps.value, (text, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "psb-steps__item"
                    }, [
                      _createElementVNode("span", _hoisted_44, _toDisplayString(index + 1), 1),
                      _createElementVNode("span", _hoisted_45, _toDisplayString(text), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('psb-cross-border.hint-mobile')), 1),
                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('psb-cross-border.hint-desktop')), 1),
                (_ctx.invoice.isTrxIdRequiredForConfirm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('invoice.transaction-id-label')), 1),
                      _createElementVNode("input", {
                        id: "psb-trx-input",
                        class: _normalizeClass(["psb-trx__input", {'is-error': _ctx.transactionIdError}]),
                        type: "text",
                        value: _ctx.transactionId,
                        placeholder: _ctx.$t('invoice.transaction-id-placeholder'),
                        onInput: onTransactionIdInput
                      }, null, 42, _hoisted_50),
                      (_ctx.transactionIdError)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.transactionIdError), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "psb-confirm",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmTransfer && _ctx.confirmTransfer(...args)), ["prevent"]))
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("svg", {
                    width: "26",
                    height: "26",
                    viewBox: "0 0 24 24",
                    fill: "none"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10",
                      fill: "currentColor"
                    }),
                    _createElementVNode("path", {
                      d: "M7.5 12.5L10.5 15.5L16.5 9",
                      stroke: "#0B1638",
                      "stroke-width": "2.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('psb-cross-border.confirm')), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "psb-cancel",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.cancelDeal(_ctx.invoice.cancelUrl)), ["prevent"]))
                }, _toDisplayString(_ctx.$t('psb-cross-border.cancel')), 1)
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_52, [
                (phase.value === 'verify')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "psb-status__icon psb-status__icon--wait" }, [
                        _createElementVNode("svg", {
                          class: "psb-spinner",
                          width: "56",
                          height: "56",
                          viewBox: "0 0 56 56",
                          fill: "none"
                        }, [
                          _createElementVNode("circle", {
                            cx: "28",
                            cy: "28",
                            r: "24",
                            stroke: "#DCE6F5",
                            "stroke-width": "5"
                          }),
                          _createElementVNode("path", {
                            d: "M52 28C52 14.7452 41.2548 4 28 4",
                            stroke: "#1D3C8F",
                            "stroke-width": "5",
                            "stroke-linecap": "round"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("h1", _hoisted_53, _toDisplayString(_ctx.$t(isDispute.value ? 'psb-cross-border.dispute-title' : 'psb-cross-border.verify-title')), 1),
                      _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.$t(isDispute.value ? 'psb-cross-border.dispute-text' : 'psb-cross-border.verify-text')), 1),
                      (canUploadReceipt.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (!receiptUploaded.value)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_55, [
                                  _createElementVNode("input", {
                                    type: "file",
                                    accept: "image/*,application/pdf",
                                    onChange: onReceiptSelected
                                  }, null, 32),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('psb-cross-border.upload-receipt')), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.$t('psb-cross-border.receipt-uploaded')), 1))
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (isPaid.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "psb-status__icon psb-status__icon--success" }, [
                          _createElementVNode("svg", {
                            width: "32",
                            height: "32",
                            viewBox: "0 0 24 24",
                            fill: "none"
                          }, [
                            _createElementVNode("path", {
                              d: "M5 12.5L10 17.5L19 7.5",
                              stroke: "currentColor",
                              "stroke-width": "2.6",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("h1", _hoisted_57, _toDisplayString(_ctx.$t('psb-cross-border.success-title')), 1),
                        _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t('psb-cross-border.success-text')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "psb-status__icon psb-status__icon--fail" }, [
                          _createElementVNode("svg", {
                            width: "30",
                            height: "30",
                            viewBox: "0 0 24 24",
                            fill: "none"
                          }, [
                            _createElementVNode("path", {
                              d: "M6 6L18 18M18 6L6 18",
                              stroke: "currentColor",
                              "stroke-width": "2.6",
                              "stroke-linecap": "round"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("h1", _hoisted_59, _toDisplayString(_ctx.$t('psb-cross-border.fail-title')), 1),
                        _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.$t('psb-cross-border.fail-text')), 1)
                      ], 64)),
                (phase.value === 'result' && returnUrl.value)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      href: returnUrl.value,
                      class: "psb-confirm psb-confirm--link"
                    }, _toDisplayString(_ctx.$t('psb-cross-border.return')), 9, _hoisted_61))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["psb-toast", {'is-visible': !!_unref(copyState).copyHintTimeout}])
    }, _toDisplayString(_ctx.$t('psb-cross-border.copied')), 3)
  ]))
}
}

})